var jQuery=$=require('jquery');
    window.jQuery=window.$=jQuery;
    var pinyin=require('pinyin')
    // var wangEditor=require('wangeditor')
    var wangEditor=window.wangEditor
    module.exports = {
       // props: ['hotelId'],
        data:function(){
            return {
                showModal:false,
                id: '',
                param:this.$route.params.id,
                method: 'hotel_create',
                show_country:false,
                show_city:false,
                show_district:false,
                name: '',
                en: '',
                user:localStorage['username'],
                country: '',
                district:'',
                countryid:'',
                cityid:'',
                districtid:'',
                pms:'',
                countryname:'',
                cityname:'',
                districtname:'',
                countrylist: {},
                city: '',
                yilong: '',
                citylist: {},
                districtlist:{},
                address: '',
                tel: '',
                num:'',
                lng: '',
                lat: '',
                type: '',
                star: '',
                map:'',
                isconfirm:false,
                roomnum: '',
                opening: '',
                redecorate: '',
                tagLib: [],
                addTagtype: '',
                addTagName: '',
                bland: '',
                url : this.baseApiPath,
                checkin: ['08','00'],
                checkout: ['08','00'],
                editor:'',
                // policies: [{
                //     name: '',
                //     content: ''
                // }],
                policies: [],
                intro: '',
                // edges: [{
                //     name: '',
                //     content: ''
                // }],
                edges: [],
                tags: [],
                status: 1,
                page: 1,
                tagshow:[]
            }
        },
        //计算属性
        computed: {

            // cityid:function(){
            //     for(item in this.citylist){
            //         if(this.citylist[item].name==this.city){
            //             return this.citylist[item].id
            //         }
            //     }
            // },
            // countryid:function(){
            //     for(item in this.citylist){
            //         if(this.countrylist[item].name==this.country){
            //             return this.countrylist[item].id
            //         }
            //     }
            // },
            //  districtid:function(){
            //     for(item in this.districtlist){
            //         if(this.districtlist[item].name==this.district){
            //             return this.districtlist[item].id
            //         }
            //     }
            // },
            designTag: function() {
                //var design=[];
                //console.log(this.tagLib)
                return this.tags.filter(function(x) {
                    // return x.type==amenity
                    //  console.log(x)
                    return x.type == "design"
                })
                
            },
            crowdTag: function() {
                return this.tags.filter(function(x) {
                    return x.type == 'crowd'
                })
            },
            atmosphereTag: function() {
                return this.tags.filter(function(x) {
                    return x.type == 'atmosphere'
                })
            },
            characteristicTag: function() {
                return this.tags.filter(function(x) {
                    return x.type == 'characteristic'
                })
            },
            tagsId:function(){
                return this.tags.map(function(x){
                    return x.id
                })
            }
        },
        ready:function(){
            window.scrollTo(0, 0);
            var that = this;
            this.editor=new wangEditor('#div1');
            this.editor.customConfig.menus = [
                'bold',  // 粗体
                'fontSize',  // 字号
                'italic',  // 斜体
                'underline',  // 下划线
                'strikeThrough',  // 删除线
                'foreColor',  // 文字颜色
                'backColor',  // 背景颜色
                'list',  // 列表
                'justify',  // 对齐方式
                'image',  // 插入图片
                'undo',  // 撤销
                'redo'  // 重复
            ];
            this.editor.customConfig.customUploadImg = function (files, insert) {
                // files 是 input 中选中的文件列表
                // insert 是获取图片 url 后，插入到编辑器的方法
                $.each(files, function(i, file) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function(file){
                        var dataURL = reader.result;
                        var data = {
                            method: 'picture_upload',
                            token: localStorage['token'],
                            file: dataURL,
                            name: file.name
                        }
                        var jqPromise = $.post(that.baseApiPath, data);
                        Promise.resolve(jqPromise)
                        .then(function(value){
                            var value= JSON.parse(value);
                            // 上传代码返回结果之后，将图片插入到编辑器中
                            insert(value.data.file);
                        })
                    }
                });
            }
            this.editor.create();
            this.param=this.id=this.$route.params.id;
            // this.$http.post(url,{
            //     method: 'district_country',
            //     token: $.cookie('token')
            // }).then(function(response){
            //  console.log(1)
            // })
            var jqPromise = $.post(this.url, {
                method: 'district_country',
                token: localStorage['token']
            });
            var realPromise = Promise.resolve(jqPromise),
            that = this;
            realPromise.then(function(val) {
                var val = JSON.parse(val)
                that.countrylist = val.data;
            });
            this.$watch('countryid', function(val) {
                // this.search(val);
                if(typeof val !== "string"){
                    val=val[0]
                }
                 var promise = $.post(this.url, {
                method: 'district_city',
                token: localStorage['token'],
                country:val
            });
            var realPromise = Promise.resolve(promise),
                that = this;
            realPromise.then(function(val) {
                var val = JSON.parse(val)
                that.citylist = val.data;
            });
            })
            this.$watch('cityid', function(val) {
                // this.search(val);
                if(typeof val !== "string"){
                    val=val[0]
                }
                var promise = $.post(this.url, {
                method: 'district_area',
                token: localStorage['token'],
                city:val,
                type:'district'
            });
            var realPromise = Promise.resolve(promise),
                that = this;
            realPromise.then(function(val) {
                var val = JSON.parse(val)
                that.districtlist = val.data;
            });
            })
            // this.$watch('city', function(val) {
            //     console.log(this.city)
            //   console.log($('#thecity').find("option:selected").text())
            // })
            if (this.id) {
                this.method = 'hotel_update';
                var jqPromise = $.post(this.url, {
                    method: 'hotel_load',
                    token: localStorage['token'],
                    id: this.id
                });
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                    var value = JSON.parse(value);
                    that.id = value.data&&value.data.id || that.id;
                    that.name = value.data&&value.data.name;
                    that.pms = value.data&&value.data.pms;
                    that.en = value.data&&value.data.en;
                    that.star = value.data&&value.data.star;
                    that.type = value.data&&value.data.type;
                    that.cityid = value.data&&value.data.city;
                    that.districtid = value.data&&value.data.district;
                    that.countryid = value.data&&value.data.country;
                    that.city = value.data&&value.data.city_name;
                    that.district = value.data&&value.data.district_name;
                    that.country = value.data&&value.data.country_name;
                    that.address = value.data&&value.data.address;
                    that.lng = value.data&&value.data.lng;
                    that.bland=value.data&&value.data.bland;
                    that.checkin=value.data&&value.data.checkin&&value.data.checkin.split(":")||[];
                    that.checkout=value.data&&value.data.checkout&&value.data.checkout.split(":")||[];
                    that.lat = value.data&&value.data.lat;
                    that.tags = value.data&&value.data.tags || [];
                    that.roomnum = value.data&&value.data.roomnum || '',
                    that.opening = value.data&&value.data.opening || '',
                    that.redecorate = value.data&&value.data.redecorate || '',
                    that.status = value.data&&value.data.status;
                    that.tel = value.data&&value.data.tel;
                    that.intro=value.data&&value.data.intro||'';
                    that.policies = value.data&&value.data.policies || [];
                    that.edges = value.data&&value.data.edges || [];

                    // console.log(that.policies[0].name);


                    // 根据下表删除数组
                    Array.prototype.remove=function(obj){ 
                        for(var i =0;i <this.length;i++){ 
                            var temp = this[i]; 
                            if(!isNaN(obj)){ 
                                temp=i; 
                            } 
                            if(temp == obj){ 
                                for(var j = i;j <this.length;j++){ 
                                    this[j]=this[j+1]; 
                                } 
                                this.length = this.length-1; 
                            } 
                        } 
                    } 
                    var 
                        // _policies = [
                        //     { name: '儿童政策', content: ''},
                        //     { name: '加床政策', content: ''},
                        //     { name: '加早政策', content: ''},
                        //     { name: '宠物政策', content: ''},
                        //     { name: '信用卡政策', content: ''}
                        // ],
                        _policies = [
                            { name: '儿童政策', content: '', help: '*注意：如无填无，如有需要年龄区分和相对应的费用', demo: '举例：房间最多入住2大1小，小孩6岁以下儿童不占床可免费入住，6-12岁儿童不占床需增加费用200,12岁以上按照成人算需要加床。 ' },
                            { name: '加床政策', content: '', help: '*注意：如无填无，如有则需告知是否可以加床 ，费用。是否有婴儿床，费用', demo: '举例： 酒店婴儿床3张，免费，需提前申请。 部分房型可以加床费450/人/天 ' },
                            { name: '加早政策', content: '', help: '*注意：如无填无，如有则需告知年龄区分，费用', demo: '举例：6岁以下儿童含早免费，6-12岁早餐费用120,12岁以上早餐费用200 ' },
                            { name: '宠物政策', content: '', help: '*注意：如无填无，如有则需告知是否可带宠物，宠物是否能进入房间，宠物限制大小，是否需要狗证。', demo: '举例：酒店可携带30kg以下有办理狗证的狗狗。'
                            },
                            { name: '信用卡政策', content: '', help: '*注意：如无填无，如有则需告知能接受什么类型的信用卡 ', demo: '举例：国内发行银联卡' }
                        ],
                        _edges = [
                            { name: '品牌理念',  content: '' },
                            { name: '设计建筑风格', content: '' },
                            { name: '特色服务与设施', content: '' },
                            { name: '地理优势/周边特色', content: '' },
                            { name: '交通信息', content: '' }
                        ];

                    for( x in that.edges) {
                        // var hasname = that.edges[x].name || '';
                        if(that.edges[x].name==undefined) {
                        }else{
                            var hasname = that.edges[x].name;
                        }
                        for( i = 0; i < _edges.length; i++ ) {
                            if(hasname ==_edges[i].name ) {
                                _edges.remove(i);
                            }
                        }
                    }

                    for( i = 0 ; i < _edges.length; i++ ) {
                        that.edges.push({name: _edges[i].name,content: _edges[i].content});
                    }

                    for( x in that.policies) {
                        if(that.policies[x].name==undefined) {
                        
                        }else{
                            var hasname = that.policies[x].name;
                        }
                        for( i = 0; i < _policies.length; i++ ) {
                            if(hasname ==_policies[i].name ) {
                                _policies.remove(i);
                            }
                        }
                    }
                    for( i = 0 ; i < _policies.length; i++ ) {
                        that.policies.push({name: _policies[i].name,content: _policies[i].content,help: _policies[i].help,demo:_policies[i].demo});
                    }
                    console.log(that.policies);
                    // return false;

                    

                    // that.policies.push({
                    //     name: '儿童政策',
                    //     content: '',
                    //     help: '*注意：如无填无，如有需要年龄区分和相对应的费用',
                    //     demo: '举例：房间最多入住2大1小，小孩6岁以下儿童不占床可免费入住，6-12岁儿童不占床需增加费用200,12岁以上按照成人算需要加床。 '
                    // },{
                    //     name: '加床政策',
                    //     content: '',
                    //     help: '*注意：如无填无，如有则需告知是否可以加床 ，费用。是否有婴儿床，费用',
                    //     demo: '举例： 酒店婴儿床3张，免费，需提前申请。 部分房型可以加床费450/人/天 '
                    // },{
                    //     name: '加早政策',
                    //     content: '',
                    //     help: '*注意：如无填无，如有则需告知年龄区分，费用',
                    //     demo: '举例：6岁以下儿童含早免费，6-12岁早餐费用120,12岁以上早餐费用200 '
                    // },{
                    //     name: '宠物政策',
                    //     content: '',
                    //     help: '*注意：如无填无，如有则需告知是否可带宠物，宠物是否能进入房间，宠物限制大小，是否需要狗证。',
                    //     demo: '举例：酒店可携带30kg以下有办理狗证的狗狗。'
                    // },{
                    //     name: '信用卡政策',
                    //     content: '',
                    //     help: '*注意：如无填无，如有则需告知能接受什么类型的信用卡 ',
                    //     demo: '举例：国内发行银联卡'
                    // })

                    // that.edges.push({
                    //     name: '品牌理念',
                    //     content: ''
                    // },{
                    //     name: '设计建筑风格',
                    //     content: ''
                    // },{
                    //     name: '特色服务与设施',
                    //     content: ''
                    // },{
                    //     name: '地理优势/周边特色',
                    //     content: ''
                    // },{
                    //     name: '交通信息',
                    //     content: ''
                    // })
                    
                    that.editor.txt.html('');
                    that.editor.txt.append(that.intro);
                    // that.editor.setValue(that.intro);

                    return value;
                })
                .then(function(value){
                      var BMap=window.BMap;
                     that.map = new BMap.Map("hotelmap");
                   
                    // console.log(that)
                     var point=new BMap.Point(that.lng,that.lat);
                     var marker = new BMap.Marker(point);
                    that.map.addOverlay(marker);
                    that.map.centerAndZoom(point,17);
                    that.map.enableScrollWheelZoom(true);
                    that.map.addEventListener("click",function(e){
                        that.lng=e.point.lng;
                        that.lat=e.point.lat;
                        that.map.clearOverlays(); 
                        point=new BMap.Point(that.lng,that.lat);
                        marker = new BMap.Marker(point);
                        that.map.addOverlay(marker);               // 将标注添加到地图中
                    });
                })

            }else{
                var BMap=window.BMap;
                that.map = new BMap.Map("hotelmap");
               
                // console.log(that)
                 var point=new BMap.Point(that.lng,that.lat);
                 var marker = new BMap.Marker(point);
                that.map.addOverlay(marker);
                that.map.centerAndZoom(point,17);
                that.map.enableScrollWheelZoom(true);
                that.map.addEventListener("click",function(e){
                    that.lng=e.point.lng;
                    that.lat=e.point.lat;
                    that.map.clearOverlays(); 
                    point=new BMap.Point(that.lng,that.lat);
                    marker = new BMap.Marker(point);
                    that.map.addOverlay(marker);               // 将标注添加到地图中
                });


                // for(i=0;i<4;i++){
                //     this.addPolicies();
                // }
            }

            $('.taglib').on('click','.tags',function(){
                $(this).attr('disabled',true)
            }) 
        },
        create:function(){
            
            // alert('s');
        },
        attached:function(){
            var that=this;
            $('.simditor-toolbar').css('width','100%')
            $('.container-fluid').on('change','input',function(){
                that.isconfirm=true;
            });
            $('.container-fluid').on('change','textarea',function(){
                that.isconfirm=true;
            });
        },
        components:{
          vselect:require('vue-strap').select

            // this.param=this.id=this.$route.params.id;
            
        },
        events:{
            bind:function(value){
                this.isconfirm=true;
            }
        },
        methods:{
            
            addhelp:function(){
                // addhelp tips for items
              
            },
            showtips:function(){
                console.log($('#policies .policie_wrapper').length);
            },
            showCountry:function(){
                this.show_city=false;
                this.show_district=false;
                this.show_country==true?this.show_country=false:this.show_country=true;
                
            },
            showCity:function(){
                this.show_country=false;
                this.show_district=false;
                this.show_city==true?this.show_city=false:this.show_city=true;
            },
            showDistrict:function(){
                 this.show_country=false;
                this.show_city=false;
                this.show_district==true?this.show_district=false:this.show_district=true;
            },
            choicecountry:function(item){
                this.country=item.name;
                this.countryid=item.id
                this.show_country=false
                this.city='请选择城市';
                this.cityname='';
            },
              choicecity:function(item){
                this.city=item.name;
                this.cityid=item.id;
                this.show_city=false
                this.district='';
                this.districtname='';
            },
              choicedistrict:function(item){
                this.district=item.name;
                this.districtid=item.id;
                this.show_district=false
            },
            getpinyin:function(){
                var that=this
                this.en=pinyin(that.name,{
                    style:pinyin.STYLE_NORMAL
                }).join('')
            },
            theLocation:function(){
                var that=this;
                var BMap=window.BMap;
               var local = new BMap.LocalSearch(that.city, {onSearchComplete:function(result){
                        var pos = result.getPoi(0);
                        if (pos === undefined || pos.point === undefined) {
                            if(result.keyword != that.address) {
                                console.log(that.address)
                                local.search(that.address);
                            } else {
                                alert("地址定位未找到..", "warning");
                            }
                            return;
                        }
                        var marker = new BMap.Marker(pos.point);
                        marker.setPosition(pos.point);
                        that.lng=pos.point.lng;that.lat=pos.point.lat;
                        that.map.centerAndZoom(pos.point, 17);
                        that.map.clearOverlays();
                         that.map.addOverlay(marker);  
                    }});

                    local.search(that.address);  
             },
            designhandle:function(e){
                var that=this;
                 var fileList = e.target.files;
                //console.log(files)
                var reader=new FileReader();
              //  console.log(that.num)
                if(fileList[0]&& fileList[0].type&& fileList[0].type.match('image.*')){
                    reader.readAsDataURL(fileList[0]);
                  }
                reader.onload = (function(file){
                    return function(e){
                      //  console.log(that.num)
                        var dataURL = reader.result;
                         var data = {
                                method: 'picture_upload',
                                token: localStorage['token'],
                                file: dataURL,
                                name:fileList[0].name
                            }
                            var jqPromise = $.post(that.baseApiPath, data);
                            var realPromise = Promise.resolve(jqPromise);
                            realPromise.then(function(value){
                                var value= JSON.parse(value);
                                that.designers[that.num].photo=value.data.file
                            }) 
                    }
                // console.log(reader.result)
                // console.log(dataURL)

                //  var output = document.getElementById('output');
                // for(var item in input.files){

                  // }
                 //  var str = "<img data-id='123145' src='"+dataURL+"'>";
                 //  $('#output').append(str);
                 // console.log(str)
                 //  output.src = dataURL;
                })(fileList[0])
            },
           uploaddesign:function(num){
            this.num=num;
           // console.log(num)
            $('.deshandle:eq('+num+')').trigger('click');
           },
           famoushandle:function(e){
                var that=this;
                 var fileList = e.target.files;
                //console.log(files)
                var reader=new FileReader();
              //  console.log(that.num)
                if(fileList[0]&& fileList[0].type&& fileList[0].type.match('image.*')){
                    reader.readAsDataURL(fileList[0]);
                  }
                reader.onload = (function(file){
                    return function(e){
                      //  console.log(that.num)
                      var dataURL = reader.result;
                         var data = {
                                method: 'picture_upload',
                                token: localStorage['token'],
                                file: dataURL,
                                name:fileList[0].name
                            }
                            var jqPromise = $.post(that.baseApiPath, data);
                            var realPromise = Promise.resolve(jqPromise);
                            realPromise.then(function(value){
                                var value= JSON.parse(value);
                                that.celebrities[that.num].photo=value.data.file
                            })  
                    }
                // console.log(reader.result)
                // console.log(dataURL)

                //  var output = document.getElementById('output');
                // for(var item in input.files){

                  // }
                 //  var str = "<img data-id='123145' src='"+dataURL+"'>";
                 //  $('#output').append(str);
                 // console.log(str)
                 //  output.src = dataURL;
                })(fileList[0])
            },
           uploadfamous:function(num){
            this.num=num;
           // console.log(num)
            $('.famhandle:eq('+num+')').trigger('click');
           },
             yilongcap: function() {
                var data = {
                    method: 'hotel_link',
                    token: localStorage['token'],
                    url: this.yilong
                }
                var jqPromise = $.post(this.url, data);
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value){
                   var value= JSON.parse(value),pos=value.data&&value.data.pos&&value.data.pos.split(',');
                    that.name=value.data&&value.data.name;
                    that.address=value.data&&value.data.address;
                    that.tel=value.data&&value.data.tel;
                    that.opening=value.data&&value.data.open;
                    that.redecorate=value.data&&value.data.decorate
                    that.lng=pos[0]
                    that.lat=pos[1]
                })
            },
            addPolicies: function() {
                // if (this.policies.length <= 3) {
                    this.policies.push({
                        name: '',
                        content: ''
                    })
                    // console.log(that.policies);
                // } else {
                //     alert('最多只能添加4个政策')
                // }

            },
            removePolicies:function(num){
                this.policies.splice(num,1)
                // that.isconfirm=true;
            },
            addEdges: function() {
                // if (this.edges.length <= 5) {
                    this.edges.push({
                        name: '',
                        content: ''
                    })
                // } else {
                //     alert('最多只能添加6个亮点')
                // }
            },
            removeEdges:function(n){
                this.edges.splice(n,1)
                // that.isconfirm=true;
            },
            showTags: function(type,tags) {
                //design
                this.addTagtype = type
                var tagPromise = $.post(this.url, {
                    method: 'tag_types',
                    token: localStorage['token'],
                    types: type,
                    tags: 1
                });
                var tagsPromise = Promise.resolve(tagPromise),
                    that = this;
                tagsPromise.then(function(value) {
                    // console.log(value)
                    var value = JSON.parse(value);
                    that.tagLib = value.data && value.data[0].tags;
                   // console.log(that.tagLib)
                })
                .then(function(value){
                  //  console.log(tags)
                  that.tagshow=[];
                  that.tagshow.length=that.tagLib.length;
                for(j in that.tagLib){
                    for(i in tags){
                        if(that.tagLib[j].id==tags[i].id){
                            that.tagshow[j]=1;
                          //  console.log(that.tagLib[j])
                        }
                    }
                }
               // console.log(that.tagshow)
                })
            },
            addTohotel: function(num) {
                // console.log(this.tags)
                    this.tags.push(this.tagLib[num])
                      this.tagshow[num]=1;
                     // console.log(this.tagshow.toString())
                    this.isconfirm=true;
                
            },
            addTag: function() {
                var promise = $.post(this.url, {
                    method: 'tag_create',
                    token: localStorage['token'],
                    type: this.addTagtype,
                    name: this.addTagName
                })
                var addtagPromise = Promise.resolve(promise),
                    that = this;
                addtagPromise.then(function(value) {
                    var value = JSON.parse(value);
                    if (value.code == 0) {
                        for(j in that.tagLib){
                          if (that.tagLib[j].id==value.data.id) {
                                alert('重复标签');
                                return
                          }  
                         }
                        that.tagLib.push(value.data);
                        that.tags.push(value.data)
                            // console.log(that.tags)
                    } else {
                        alert(value.message)
                    }
                    return value
                })
                .then(function(value){
                    that.addTagName=""
                    that.isconfirm=true;
                })
            },
            removedesign:function(n){
                var n=n,that=this;
                this.tags=this.tags.filter(function(x){
                    return  x!=that.designTag[n];
                })
               // this.designTag.splice(n,1)
            },
            removecrowd:function(n){
               var n=n,that=this;
                this.tags=this.tags.filter(function(x){
                    return  x!=that.crowdTag[n];
                })
            },
             removeatmosphere:function(n){
                var n=n,that=this;
                this.tags=this.tags.filter(function(x){
                    return  x!=that.atmosphereTag[n];
                })
            },
             removecharacteristic:function(n){
                var n=n,that=this;
                this.tags=this.tags.filter(function(x){
                    return  x!=that.characteristicTag[n];
                })
            },
             basicSubmit: function() {
                //console.log(this)
                     // var policiesvalid=true;
                     //  var edgesvalid=true;
                     //  var that=this;
                     //  this.policies.map(function(x){
                     //   if(x.name.length>6 && x.content.length>50){
                     //      policiesvalid=false;
                     //       }
                     //      })
                     //  this.edges.map(function(x){
                     //   if(x.name.length>12 && x.content.length>50){
                     //    edgesvalid=false;
                     //           }
                     // })
                     //  if(!policiesvalid){
                     //    alert('政策字数超过限制')
                     //  }
                     //  if(!edgesvalid){
                     //    alert('亮点字数超过限制')
                     //  }
                var data = {
                    id: this.id || this.param,
                    method: this.method,
                    token: localStorage['token'],
                    name: this.name,
                    en: this.en,
                    // country: this.country[0],
                    // city:this.city[0],
                    address: this.address,
                    tel: this.tel,
                    lng: this.lng - 0,
                    lat: this.lat - 0,
                    pms: this.pms,
                    type: this.type,
                    star: this.star,
                    roomnum: this.roomnum - 0,
                    opening: this.opening,
                    redecorate: this.redecorate,
                    bland: this.bland,
                    checkin: this.checkin.join(':'),
                    checkout: this.checkout.join(':'),
                    policies: this.policies,
                    edges: this.edges,
                    celebrities: this.celebrities,
                    designers: this.designers,
                    tags: this.tagsId,
                    country:this.countryid,
                    city:this.cityid,
                    district:this.districtid,
                    status: this.status,
                    intro: ''
                };
                data.intro = this.editor.txt.html();
                //console.log(data)
                var jqPromise = $.post(this.url, data);
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                    var value = JSON.parse(value);
                    if (value.code == 0) {
                        that.id=that.param=value.data;
                        that.isconfirm=false;
                         that.intro=that.editor.txt.html();
                        that.$route.router.go({name:'guestroom',params:{id:that.id}})
                    } else {
                        alert(value.message)
                    }
                    return value
                })
                console.log(data);
                return false;
            }
        },
        route:{
            activate:function(){
                window.scrollTo(0, 0);
            },
            canDeactivate:function(transition){
                if(this.isconfirm||this.intro!=this.editor.txt.html()){
                    if(confirm('还未保存，确定退出？')){
                        transition.next()
                    }else{
                        transition.abort()
                    }
                }else{
                    transition.next()
                }
                
            },
            data: function(transition) {
               this.country='请选择国家';
               this.city='请选择城市';
               this.param=this.id=this.$route.params.id;
               this.$dispatch('pageinfo','基本信息');
            // this.$http.post(url,{
            //     method: 'district_country',
            //     token: $.cookie('token')
            // }).then(function(response){
            //  console.log(1)
            // })
            var jqPromise = $.post(this.url, {
                method: 'district_country',
                token: localStorage['token']
            });
            var realPromise = Promise.resolve(jqPromise),
                that = this;
            realPromise.then(function(val) {
                var val = JSON.parse(val)
                that.countrylist = val.data;
            });
            if (this.id) {
                this.method = 'hotel_update';
                var jqPromise = $.post(this.url, {
                    method: 'hotel_load',
                    token: localStorage['token'],
                    id: this.id
                });
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                    var value = JSON.parse(value);
                    that.id = value.data&&value.data.id || that.id;
                    that.name = value.data&&value.data.name;
                    that.en = value.data&&value.data.en;
                    that.star = value.data&&value.data.star;
                    that.type = value.data&&value.data.type;
                    that.pms = value.data&&value.data.pms;
                    that.cityid = value.data&&value.data.city;
                    that.districtid = value.data&&value.data.district;
                    that.countryid = value.data&&value.data.country;
                    that.city = value.data&&value.data.city_name;
                    that.district = value.data&&value.data.district_name;
                    that.country = value.data&&value.data.country_name;
                    that.address = value.data&&value.data.address;
                    that.lng = value.data&&value.data.lng;
                    that.bland=value.data&&value.data.bland;
                    that.checkin=value.data&&value.data.checkin&&value.data.checkin.split(":")||[];
                    that.checkout=value.data&&value.data.checkout&&value.data.checkout.split(":")||[];
                    that.lat = value.data&&value.data.lat;
                    that.tags = value.data&&value.data.tags || [];
                    that.roomnum = value.data&&value.data.roomnum || '',
                    that.opening = value.data&&value.data.opening || '',
                    that.redecorate = value.data&&value.data.redecorate || '',
                    that.status = value.data&&value.data.status;
                    that.tel = value.data&&value.data.tel;
                    that.intro=value.data&&value.data.intro||'';
                    that.policies = value.data&&value.data.policies || [];
                    that.edges = value.data&&value.data.edges || [];

                    // 根据下表删除数组
                    Array.prototype.remove=function(obj){ 
                        for(var i =0;i <this.length;i++){ 
                            var temp = this[i]; 
                            if(!isNaN(obj)){ 
                                temp=i; 
                            } 
                            if(temp == obj){ 
                                for(var j = i;j <this.length;j++){ 
                                    this[j]=this[j+1]; 
                                } 
                                this.length = this.length-1; 
                            } 
                        } 
                    } 

                    var 
                        _policies = [
                            { name: '儿童政策', content: '', help: '*注意：如无填无，如有需要年龄区分和相对应的费用', demo: '举例：房间最多入住2大1小，小孩6岁以下儿童不占床可免费入住，6-12岁儿童不占床需增加费用200,12岁以上按照成人算需要加床。 ' },
                            { name: '加床政策', content: '', help: '*注意：如无填无，如有则需告知是否可以加床 ，费用。是否有婴儿床，费用', demo: '举例： 酒店婴儿床3张，免费，需提前申请。 部分房型可以加床费450/人/天 ' },
                            { name: '加早政策', content: '', help: '*注意：如无填无，如有则需告知年龄区分，费用', demo: '举例：6岁以下儿童含早免费，6-12岁早餐费用120,12岁以上早餐费用200 ' },
                            { name: '宠物政策', content: '', help: '*注意：如无填无，如有则需告知是否可带宠物，宠物是否能进入房间，宠物限制大小，是否需要狗证。', demo: '举例：酒店可携带30kg以下有办理狗证的狗狗。'
                            },
                            { name: '信用卡政策', content: '', help: '*注意：如无填无，如有则需告知能接受什么类型的信用卡 ', demo: '举例：国内发行银联卡' }
                        ],
                        // _policies = [
                        //     { name: '儿童政策', content: ''},
                        //     { name: '加床政策', content: ''},
                        //     { name: '加早政策', content: ''},
                        //     { name: '宠物政策', content: ''},
                        //     { name: '信用卡政策', content: ''}
                        // ],
                        _edges = [
                            { name: '品牌理念',  content: '' },
                            { name: '设计建筑风格', content: '' },
                            { name: '特色服务与设施', content: '' },
                            { name: '地理优势/周边特色', content: '' },
                            { name: '交通信息', content: '' }
                        ];

                    for( x in that.edges) {
                        // var hasname = that.edges[x].name || '';
                        if(that.edges[x].name==undefined) {

                        }else{
                            var hasname = that.edges[x].name;
                        }
                        for( i = 0; i < _edges.length; i++ ) {
                            if(hasname ==_edges[i].name ) {
                                _edges.remove(i);
                            }
                        }
                    }
                    for( i = 0 ; i < _edges.length; i++ ) {
                        that.edges.push({name: _edges[i].name,content: _edges[i].content});
                    }

                    for( x in that.policies) {
                        if(that.policies[x].name==undefined) {

                        }else{
                            var hasname = that.policies[x].name;
                        }
                        for( i = 0; i < _policies.length; i++ ) {
                            if(hasname ==_policies[i].name ) {
                                _policies.remove(i);
                            }
                        }
                    }
                    for( i = 0 ; i < _policies.length; i++ ) {
                        that.policies.push({name: _policies[i].name,content: _policies[i].content,help: _policies[i].help,demo:_policies[i].demo});
                    }


                    that.editor.txt.html('');
                    that.editor.txt.append(that.intro);
                    return value;
                })
                .then(function(value){
                    that.countryinput=$('#thecountry').find("option:selected").text();
                    return value
                })
                .then(function(value){
                    that.cityinput=$('#thecity').find("option:selected").text()
                    return value
                })
                .then(function(value){
                    if(that.map){
                        that.map.clearOverlays(); 
                        var newlat=that.lat-0+0.0029;
                        var newlng=that.lng-0.007346;
                    var point=new BMap.Point(that.lng,that.lat);
                    var point2=new BMap.Point(newlng,newlat);
                    that.map.centerAndZoom(point,17);
                      var marker = new BMap.Marker(point);
                     that.map.addOverlay(marker);
                     
                    that.map.enableScrollWheelZoom(true);
                    }
                    return value
                })
                transition.next()
            }else{
                this.method = 'hotel_create';
                that.id = '';
                that.country='请选择国家';
                that.city='请选择城市';
                that.name = '';
                that.en = '';
                that.star = '';
                that.type = '';
                that.cityid = '';
                that.districtid = '';
                that.countryid = '';
                that.district = '';
                that.address = '';
                that.lng = '';
                that.bland='';
                that.checkin=[];
                that.checkout=[];
                that.lat = '';
                that.tags = [];
                that.roomnum = '',
                that.opening = '',
                that.redecorate ='',
                that.status = '';
                that.tel = '';
                that.intro='';
                that.policies = [{
                    name: '儿童政策',
                    content: '',
                    help: '*注意：如无填无，如有需要年龄区分和相对应的费用',
                    demo: '举例：房间最多入住2大1小，小孩6岁以下儿童不占床可免费入住，6-12岁儿童不占床需增加费用200,12岁以上按照成人算需要加床。 '
                },{
                    name: '加床政策',
                    content: '',
                    help: '*注意：如无填无，如有则需告知是否可以加床 ，费用。是否有婴儿床，费用',
                    demo: '举例： 酒店婴儿床3张，免费，需提前申请。 部分房型可以加床费450/人/天 '
                },{
                    name: '加早政策',
                    content: '',
                    help: '*注意：如无填无，如有则需告知年龄区分，费用',
                    demo: '举例：6岁以下儿童含早免费，6-12岁早餐费用120,12岁以上早餐费用200 '
                },{
                    name: '宠物政策',
                    content: '',
                    help: '*注意：如无填无，如有则需告知是否可带宠物，宠物是否能进入房间，宠物限制大小，是否需要狗证。',
                    demo: '举例：酒店可携带30kg以下有办理狗证的狗狗。'
                },{
                    name: '信用卡政策',
                    content: '',
                    help: '*注意：如无填无，如有则需告知能接受什么类型的信用卡 ',
                    demo: '举例：国内发行银联卡'
                }];
                that.edges = [{
                    name: '品牌理念',
                    content: ''
                },{
                    name: '设计建筑风格',
                    content: ''
                },{
                    name: '特色服务与设施',
                    content: ''
                },{
                    name: '地理优势/周边特色',
                    content: ''
                },{
                    name: '交通信息',
                    content: ''
                }]
                that.editor&&that.editor.txt&&that.editor.txt.html('');
                that.editor&&that.editor.txt&&that.editor.txt.append(that.intro);

                transition.next()
            }  
        },
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/basicinfo.vue
// module id = 67
// module chunks = 0